<style scoped="scoped" lang="scss">
._demo /deep/.el-transfer-panel:last-child {
  border-right: none;
}
.option-item {
  border-bottom: 1px solid #eaeaea; // 设置底部横线
  padding-bottom: 4px; // 增加内边距让横线与文本分隔
  margin-left: 10px; // 左侧缩进
  margin-right: 10px; // 右侧缩进
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/formed/document/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <!--						<yi_cross_select :component="'web_base_equipment_list'" :max="1"-->
            <!--							:ids.sync="yt.conditions.equipmentId"></yi_cross_select>-->

            <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('peifang')">
            <el-input v-model="yt.conditions.mouldNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpin')">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.conditions.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('moju')">
            <yi_data_select :max="1" :type="'mould'" :ids.sync="yt.conditions.mouldId"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button size="mini" @click="yt.showEditDialog('xinzengdangan', scope.row, 'w1')" type="primary" v-if="utils.checkPower('web_process_distribution_forming_document_create')">
          {{ $t('xinzengdangan') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('huoqudangan', scope.row, 'w1')" plain v-if="utils.checkPower('web_process_distribution_forming_document_get')">
          {{ $t('huoqudangan') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('xiafachengxingdangan', scope.row, 'w1'),getBrMouldNoList(scope.row.equipmentId)">
              {{ $t('xiafachengxingdangan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('fuzhidangan', scope.row, 'w1')">
              {{ $t('fuzhidangan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/craft/formed/document/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzengdangan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeiSNshebeimingcheng')" required>
            <yi_cross_select :component="'web_base_equipment_list'" :selectTitle="'sn,name'" :max="1" :ids.sync="yt.editObj.equipmentId"></yi_cross_select>
          </el-form-item>
          <el-form-item style="display: flex;flex-wrap: nowrap;" :label="$t('chengxingdangan')" required>
            <yi_upload style="margin-left: 20px" :accept="'mcm,mld,kpdsa'" :ids.sync="yt.editObj.fileId" :limit="1">
              <div slot="limitMsg"></div>
            </yi_upload>
            <div>
              <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                {{ $t('zuiduoshangchuan') }}
              </span>
              <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                <span>1</span>
                <span style="color: #909399;font-size: 14px;font-weight: normal;">
                  {{ $t('zizhichiwenjian') }}
                </span>
              </span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('mingcheng')">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpin')">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.editObj.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('moju')">
            <yi_data_select :max="1" :type="'mould'" :ids.sync="yt.editObj.mouldId"> </yi_data_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/craft/formed/document/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑档案 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeiSN')" required class="noborder">
            <el-input disabled v-model="yt.editObj.equipment.sn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required class="noborder">
            <el-input disabled v-model="yt.editObj.equipment.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('peifang')" required>
            <el-input v-model="yt.editObj.mouldNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mingcheng')">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpin')">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.editObj.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('moju')">
            <yi_data_select :max="1" :type="'mould'" :ids.sync="yt.editObj.mouldId"> </yi_data_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/craft/formed/document/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 获取档案 -->
      <template v-if="yt.editObj.action == 'huoqudangan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeiSNshebeimingcheng')" required>
            <yi_data_select :max="1" :type="'equipment'" :ids.sync="yt.editObj.equipmentId"></yi_data_select>
          </el-form-item>
          <!--         <div style="display: flex;flex-wrap: nowrap">-->
          <div>
            <el-form-item :label="$t('peifang')" required>
              <div style="overflow: auto;height: 160px;width: 192px;border: 1px solid #eae9e9">
                <el-checkbox-group :max=1 style="margin-left: 8px" v-model="checkedCities" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="city in getMouldNoList" :label="city" :key="city" style="display: block;">
                    {{ city.mouldSuffix ? (city.mouldNo + '.#' + city.mouldSuffix) : city.mouldNo }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="$t('chengxingdangan')" required>
              <el-input disabled v-model="filesName"> </el-input>
            </el-form-item>
          </div>
          <el-form-item :label="$t('mingcheng')">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpin')">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.editObj.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('moju')">
            <yi_data_select :max="1" :type="'mould'" :ids.sync="yt.editObj.mouldId"> </yi_data_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button :loading="getDocLoading" size="mini" @click="syncLatestMouldNo" type="primary">
            {{ $t('huoquzuixinpeifangliebiao') }}
          </el-button>
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="getDocLoading" size="mini" @click="saveForm" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 复制档案 -->
      <template v-if="yt.editObj.action == 'fuzhidangan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <div style="font-size: 16px;color: #303133;font-weight: 400">{{ $t('yuanchengxingdanganxinxi') }}</div>
          <el-form-item class="noborder" :label="$t('shebeiSNshebeimingcheng')" required style="margin-top: 10px">
            <yi_cross_select disabled :component="'web_base_equipment_list'" :selectTitle="'sn,name'" :max="1" :ids.sync="yt.editObj.equipmentId"></yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('peifang')" required>
            <el-input disabled v-model="yt.editObj.mouldNo"></el-input>
          </el-form-item>
          <div style="font-size: 16px;color: #303133;font-weight: 400">{{ $t('xiugaihouchengxingdanganxinxi') }}</div>
          <el-form-item :label="$t('yuesutiaojianplckongzhiqi')" required style="margin-top: 10px">
            <yi_dictionary_select :max="1" :type="'YSTJ'" :ids.sync="yt.editObj.value" disabled> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shebeiSNshebeimingcheng')" required style="margin-top: 10px">
            <el-select :disabled="disabledEquipment" filterable :clearable="true" v-model="yt.editObj.equipmentIds">
              <el-option v-for="(item, index) in equipmentList" :key="index" :label="item.equipmentSnAndName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('peifang')" required>
            <el-input v-model="yt.editObj.mouldNos"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mingcheng')">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpin')">
            <yi_data_select :multiple="false" :type="'material2'" :ids.sync="yt.editObj.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('moju')">
            <yi_data_select :max="1" :type="'mould'" :ids.sync="yt.editObj.mouldId"> </yi_data_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/craft/formed/document/copy', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'xiafachengxingdangan'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yuesutiaojianplckongzhiqi')" required style="margin-top: 10px">
            <yi_dictionary_select :max="1" :type="'YSTJ'" :ids.sync="yt.editObj.value" disabled> </yi_dictionary_select>
          </el-form-item>
          <!-- 增加点击事件 ,getBrMouldNoList传递选中的id-->
          <el-form-item :label="$t('shebeiSNshebeimingcheng')" required>
            <el-select :disabled="disabledEquipment" filterable :clearable="true" v-model="equipmentVal" v-on:change="getBrMouldNoList">
              <el-option v-for="(item, index) in equipmentList" :key="index" :label="item.equipmentSnAndName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <!--当brMouldNo.equipmentType为4时，则显示序号数组brMouldNoArr下拉框 -->
          <el-form-item v-if="structureEquipmentType == 4" :label="$t('配方序号')" required>
            <el-select v-model="brSerialNo" filterable :clearable="true" placeholder="请选择">
              <el-option
                  v-for="(item, index) in fullIndices"
                  :key="index"
                  :label="item.indexLabel"
                  :value="item.indexLabel" class="option-item">
                <span style="float: left">{{ item.indexLabel }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.mouldNo }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="distributeLoading" size="mini" @click="saveSumit" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
// const cityOptions = ['mo123.#001', 'mo123.#002', 'mo123.#003', 'mo123.#004','mo123.#005'];
// const cityOptions = this.getMouldNoList;
export default {
  name: 'web_process_distribution_forming_document',
  data() {
    return {
      equipmentVal: [],
      checkAll: false,
      checkedCities: [],
      getMouldNoList: [],
      getFileNameMap: {},
      filesName: null,
      mouldNoName: null,
      checkedMouldNoInfoId: null,
      // checkedCities: ['mo123.#001'],
      cities: this.getMouldNoList,
      isIndeterminate: true,
      selectedData: [],
      equipmentList: [],
      disabledEquipment: true,
      getDocLoading:false,
      distributeLoading:false,
      structureEquipmentType: null,
      brMouldNoArr: [],
      emptyIndices: [],
      fullIndices: [],
      brSerialNo: null,
      data: [
        {
          key: 1,
          label: this.$t('xuanxiang') + 1
        },
        {
          key: 2,
          label: this.$t('xuanxiang') + 2
        },
        {
          key: 3,
          label: this.$t('xuanxiang') + 3
        },
        {
          key: 4,
          label: this.$t('xuanxiang') + 4
        },
        {
          key: 5,
          label: this.$t('xuanxiang') + 5
        }
      ],
      titles: [this.$t('kexuanxiang'), this.$t('yixuanxiang')],
      props: {
        key: 'key',
        label: 'label'
      },
      codeAndDesc: '',
      columns: [
        {
          label: 'shebeiSN',
          prop: 'equipment.sn',
          width: 180
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 180
        },
        {
          label: 'mingcheng',
          prop: 'name',
          width: 180
        },
        {
          label: 'peifang',
          prop: 'mouldNo',
          width: 180
        },
        {
          label: 'chengxingdangan',
          prop: 'fileName'
          // width: 180,
        },
        {
          label: 'yuanshebeimingcheng',
          prop: 'originEquipment.name',
          width: 180
        },
        {
          label: 'chanpin',
          prop: 'material.name',
          width: 180
        },
        {
          label: 'muju',
          prop: 'mould.name',
          width: 180
        },
        {
          label: 'xiugaishijian',
          prop: 'updateTime',
          type: 'time',
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 260,
          fixed: 'right'
        }
      ]
    };
  },
  watch: {
    'yt.editObj': {
      handler(n, o) {
        if (n.value) {
          this.equipmentVal = [];
          this.getArchivalEquipment();
          this.disabledEquipment = false;
        }
      },
      immediate: false,
      deep: false
    },
    'yt.isShowEditDialog': {
      handler(n, o) {
        if (n == false) {
          this.disabledEquipment = true;
          this.getMouldNoList = [];
          this.checkedCities = [];
          this.filesName = '';
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.equipmentId': {
      handler(n) {
        if (n) {
          if (this.yt.editObj.action != 'xiafachengxingdangan'){
            this.getMouldNo();
          }
          this.beforeShowBianjiDialog();
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'updateTime desc'
      };
      //console.log(this.yt.get(1));
      this.yt.get(1);
    }, 300);
  },
  methods: {
    beforeShowBianjiDialog() {
      if (this.yt.editObj.equipment.plcControllerModel) {
        this.$set(this.yt.editObj, 'value', this.yt.editObj.equipment.plcControllerModel);
        this.equipmentVal = this.yt.editObj.equipmentId;
        this.disabledEquipment = false;
      } else {
        this.$set(this.yt.editObj, 'value', '');
      }
      //this.getArchivalEquipment();

    },
    handleCheckedCitiesChange(value) {
      if (value.length > 0) {
        if (value[0].mouldSuffix) {
          this.filesName = value[0].mouldNo + '.#' + value[0].mouldSuffix + ".mld"
          this.mouldNoName = value[0].mouldNo + '.#' + value[0].mouldSuffix
        } else {
          this.filesName = value[0].mouldNo +'.' +  value[0].fileSuffix
          this.mouldNoName = value[0].mouldNo
        }
        this.checkedMouldNoInfoId = value[0].id
      } else {
        this.filesName = ''
      }
    },
    //获取档案保存
    saveForm() {
      this.getDocLoading = true;
      let params = {
        mouldNo: this.mouldNoName,
        mouldNoInfoId: this.checkedMouldNoInfoId,
        equipmentId: this.yt.editObj.equipmentId,
        matialId: this.yt.editObj.materialId,
        mouldId: this.yt.editObj.mouldId
        // oldEquipmentId: this.yt.editObj.equipmentId
      };
      return this.http
        .post('/web/craft/formed/document/getDocument/save', params)
        .then(response => {
          this.utils.successMessage(this.$t('tongbuzhongqingdengdai'));
          // this.yt.isShowEditDialog = false;

          // 设置5秒后刷新页面
          setTimeout(() => {
            this.getDocLoading = false;
            this.yt.isShowEditDialog = false;
            this.yt.conditions = {
              orderBy: 'createTime desc'
            };
            this.yt.get(1);
          }, 8000);
        })
        .catch(error => {
          this.getDocLoading = false;
          this.utils.errorMessage(error);
        });
    },
    syncLatestMouldNo() {
      // 如果this.yt.editObj.equipmentId为空，则提示请先选择设备
      if (!this.yt.editObj.equipmentId) {
        this.$message.error(this.$t('qingxuanzeshebei'));
        return;
      }
      this.getDocLoading = true;
      return this.http
          .get('/web/craft/formed/document/syncLatestMouldNo', {
            params: {
              equipmentId: this.yt.editObj.equipmentId
            }
          })
          .then(response => {
            this.utils.successMessage(this.$t('tongbuzhongqingdengdai'));
            // this.yt.isShowEditDialog = false;

            // 设置5秒后刷新页面
            setTimeout(() => {
              this.getDocLoading = false;
              this.getMouldNo();
            }, 8000);
          })
          .catch(error => {
            this.getDocLoading = false;
            this.utils.errorMessage(error);
          });
    },
    //下发成型档案保存
    saveSumit() {
      if (this.structureEquipmentType === '4' && this.brSerialNo == null) {
        this.utils.errorMessage(this.$t('qingxuanzepeifangxuhao'));
        return;
      }
      this.distributeLoading = true;
      let params = {
        id: this.yt.editObj.id,
        mouldNo: this.yt.editObj.mouldNo,
        newEquipmentId: this.equipmentVal,
        originEquipmentId: this.yt.editObj.equipmentId,
        constraints: this.yt.editObj.value,
        brSerialNo: this.brSerialNo
      };
      return this.http
        .post('/web/craft/formed/document/validMould', params)
        .then(response => {
          this.distributeLoading = false;
          if (response.data == false) {
            this.yt.isShowEditDialog = false;
            this.utils.successMessage(this.$t(response.msg));
            setTimeout(() => {
              this.$router.push({
                path: '/web/process_distribution/forming_document_issued_log',
                query: { equipmentId: this.equipmentVal }
              });
            }, 1000)
          }
          if (response.data == true) {
            //当前模号的序号已经存在，是否自动修改序号再下发?
            this.$confirm('当前模号的序号已经存在，是否进行覆盖?', this.$t('jinggao'), {
              confirmButtonText: this.$t('shi'),
              cancelButtonText: this.$t('fou'),
              type: 'warning'
            })
              .then(() => {
                this.getDistributeMoldingFiles();
                this.yt.isShowEditDialog = false;
              })
              .catch(() => {});
          }
          // console.log('fffffffv',response.data)
          // this.yt.isShowEditDialog = false
        }).catch(error => {
            this.distributeLoading = false;
            this.utils.errorMessage(error);
          }).finally(() => {
            this.distributeLoading = false;
          });
    },
    // craft/formed/archives/distributeMoldingFiles
    getDistributeMoldingFiles() {
      let params = {
        id:this.yt.editObj.id,
        constraints: this.yt.editObj.value,
        mouldNo: this.yt.editObj.mouldNo,
        newEquipmentId: this.equipmentVal,
        originEquipmentId: this.yt.editObj.equipmentId,
        brSerialNo: this.brSerialNo
      };
      return this.http
        .post('/web/craft/formed/document/distributeMoldingFiles', params)
        .then(response => {
          this.utils.successMessage(this.$t(response.msg));
          // this.yt.isShowEditDialog = false
          setTimeout(() => {
            this.$router.push('/web/process_distribution/forming_document_issued_log');
          }, 1000)
        })
        .catch(error => {
          this.utils.errorMessage(error);
        }).finally(() => {
            this.brSerialNo = null;
          });
    },
    beforeAdd(params, url) {
      params.oldId = params.id;
      params.equipmentId = params.equipmentIds;
      params.mouldNo = params.mouldNos;
      return params;
    },
    getArchivalEquipment() {
      this.http
        .get('/web/equipment/standing_book/getArchivalEquipment', {
          params: {
            equipmentId: this.yt.editObj.equipmentId,
            constraintConditionValue: this.yt.editObj.value,
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.equipmentList = res.data;
        });
    },
    getMouldNo() {
      // 重置已选择数据
      this.checkedCities = [];
      this.filesName = '';
      this.mouldNoName = '',
      this.checkedMouldNoInfoId = null,
      this.http
        .get('/web/craft/formed/document/getMouldNo', {
          params: {
            equipmentId: this.yt.editObj.equipmentId
          }
        })
        .then(res => {
          this.getMouldNoList = res.data;
          // 如果getMouldNoList里面的对象，属性mouldSuffix都不为空，则根据mouldSuffix进行排序
          if (this.getMouldNoList.some(item => item.mouldSuffix !== null && item.mouldSuffix !== undefined)) {
            this.getMouldNoList.sort((a, b) => {
              return a.mouldSuffix - b.mouldSuffix;
            });
          } else if (this.getMouldNoList.some(item => item.mouldNo.indexOf('.#') !== -1)) {
            // 如果里面的数据任意一个包含“.#",则对getMouldNoList进行排序，排序根据”.#“后面的数字进行
            this.getMouldNoList.sort((a, b) => {
              return a.mouldNo.split('.#')[1] - b.mouldNo.split('.#')[1];
            });
          }
          console.log('data', res.data);
        });
    },
    getMouldNoFileName(key) {
      return this.getFileNameMap[key];
    },
    // 获取结构体，并将结果里面第一个对象的brMouldNoArr改为数组，用于el-select
    getBrMouldNoList(equipmentId1) {
      if (equipmentId1){
        this.equipmentVal = equipmentId1;
      }
      // 清空this.emptyIndices
      this.emptyIndices = [];
      this.brSerialNo = null;
      return this.http
        .get('/web/craft/formed/document/structure/page', {
          params: {
            equipmentId: this.equipmentVal
          }
        })
        .then(res => {

          if (res.data.rows.length == 0) {
            this.structureEquipmentType = 0;
          } else {
            this.structureEquipmentType = res.data.rows[0].equipmentType;
            if (res.data.rows[0].equipmentType === '4') {
              try {
                this.brMouldNoArr = res.data.rows[0].brMouldNoArr.split(',');
                this.brMouldNoArr = this.brMouldNoArr.map(item => {
                  return item.replace(/^"|"$/g, '');
                });
                // 遍历brMouldNoArr数组
                // 初始化fullIndices数组
                this.fullIndices = this.brMouldNoArr.map((mouldNo, index) => ({
                  indexLabel: index,
                  mouldNo: mouldNo
                }));
              } catch (error) {
                console.error('Error splitting brMouldNoArr:', error);
                this.brMouldNoArr = [];
              }
            }
          }

        });
    },
  }
};
</script>
